<template>
  <input-text
    v-if="inputSelecionado === 'Numerico'"
    v-model="valorPadraoNumerico"
    class="col-12 col-md-4"
    :label="$t('modulos.campo_adicional.formulario.valorPadrao')"
    :sem-label="semLabel"
    type="number"
    :obrigatorio="obrigatorio"
  />
  <input-text
    v-else-if="inputSelecionado === 'Texto'"
    v-model="form.valorPadrao"
    class="col-12 col-md-4"
    :label="$t('modulos.campo_adicional.formulario.valorPadrao')"
    :sem-label="semLabel"
    type="text"
    :obrigatorio="obrigatorio"
  />
  <input-date
    v-else-if="inputSelecionado === 'Data'"
    v-model="form.valorPadrao"
    class="col-12 col-md-4"
    :label="$t('modulos.campo_adicional.formulario.valorPadrao')"
    :sem-label="semLabel"
    :pode-limpar-data="true"
    :obrigatorio="obrigatorio"
  />
  <div
    v-else-if="inputSelecionado === 'Angulo'"
    class="input-padrao col-12 col-md-4"
  >
    <span class="mb-3 d-block v-label--externo d-flex">
      <span class="label" v-if="!obrigatorio">
        {{ $t('modulos.campo_adicional.formulario.valorPadrao') }}
      </span>
      <span class="label" v-else>
        {{ $t('modulos.campo_adicional.formulario.valorPadrao') + ' *' }}
      </span>
    </span>
    <input-calibracao
      v-model="form.valorPadrao"
      sistema="Sexagesimal"
      background-color="transparent"
      selecionar-texto-on-focus
      :obrigatorio="obrigatorio"
    />
  </div>
  <!-- <input-text
    v-else-if="inputSelecionado === 'Angulo'"
    v-model="form.valorPadrao"
    v-mask="mascaraAngulo"
    class="col-12 col-md-4"
    :label="$t('modulos.campo_adicional.formulario.valorPadrao')"
    :sem-label="semLabel"
    type="text"
  /> -->
  <input-select
    v-else-if="inputSelecionado === 'Booleano'"
    v-model="form.valorPadrao"
    :options="opcoes.booleano"
    class="col-12 col-md-4"
    :label="$t('modulos.campo_adicional.formulario.valorPadrao')"
    :sem-label="semLabel"
    :obrigatorio="obrigatorio"
  />
  <input-combobox-text
    v-else-if="inputSelecionado === 'ListaEscolhaUnica'"
    v-model="form.valorPadrao"
    class="col-12 col-md-4"
    :options="form.itens"
    :label="$t('modulos.campo_adicional.formulario.valorPadrao')"
    :sem-label="semLabel"
    :placeholder="'Valor Padrão'"
    :multiplo="false"
    :append-icon="'$downArrow'"
    somente-combo-box
    chips
    :obrigatorio="obrigatorio"
  />
  <input-combobox-text
    v-else-if="inputSelecionado === 'ListaMultiplaEscolha'"
    v-model="form.valorPadrao"
    class="col-12 col-md-4"
    :label="$t('modulos.campo_adicional.formulario.valorPadrao')"
    :sem-label="semLabel"
    :placeholder="'Valor Padrão'"
    :options="form.itens"
    :append-icon="'$downArrow'"
    multiplo
    somente-combo-box
    chips
    :obrigatorio="obrigatorio"
  />
  <input-text
    v-else
    v-model="form.valorPadrao"
    class="col-12 col-md-4"
    :label="$t('modulos.campo_adicional.formulario.valorPadrao')"
    :sem-label="semLabel"
    type="number"
    :obrigatorio="obrigatorio"
  />
</template>

<script>
import helpers from '@/common/utils/helpers';
import { InputCalibracao } from '@components/inputs';

export default {
  components: {
    InputCalibracao,
  },
  props: {
    inputSelecionado: { type: String, default: 'Numerico' },
    form: {},
    exibeLabel: { type: Boolean, default: true },
    obrigatorio: { type: Boolean, default: false },
  },
  data() {
    return {
      opcoes: {
        booleano: [
          {
            text: this.$t('enums.boleano.sim'),
            value: 'true',
          },
          {
            text: this.$t('enums.boleano.nao'),
            value: 'false',
          },
          {
            text: this.$t('enums.boleano.nulo'),
            value: null,
          },
        ],
      },
    };
  },
  computed: {
    valorPadraoNumerico: {
      get() {
        return this.form.valorPadrao == null || this.form.valorPadrao == ''
          ? ''
          : this.form.valorPadrao;
      },
      set(value) {
        this.form.valorPadrao = value;
      },
    },
    mascaraAngulo() {
      return helpers.removerMascara(this.form.valorPadrao).length > 6
        ? `###°##'##"`
        : `##°##'##"`;
    },
    semLabel() {
      return this.exibeLabel ? false : true;
    },
  },
};
</script>
